export default "__VITE_ASSET__DjgyqVYh__"